var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "numslider" }, [
    _c("div", { staticClass: "numslider__title" }, [
      _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "numslider__value" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.view) + " " + _vm._s(_vm.postfix) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", {
      ref: "slider",
      staticClass: "numslider__slider",
      attrs: { value: _vm.value }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "numslider__anchors" }, [
      _c(
        "span",
        {
          staticClass: "anchor filled at-start",
          on: {
            click: function($event) {
              return _vm.setValue(_vm.min)
            }
          }
        },
        [_vm._v(_vm._s(_vm._f("russianCurrency")(_vm.min, _vm.postfix)))]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "anchor at-end",
          on: {
            click: function($event) {
              return _vm.setValue(_vm.max)
            }
          }
        },
        [_vm._v(_vm._s(_vm._f("russianCurrency")(_vm.max, _vm.postfix)))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }